import { getCommentingAPI } from '../api/Commenting';
export default function useCommentingApi() {
  return getCommentingAPI();
}